import dnsRetrieveDomainRecordsDialog from "./dns-retrieve-domain-records-dialog";
import dnsSelectTemplateDialog from "./dns-select-template-dialog";
import dnsTemplate from "./dns-template";
import domainInfo from "./domain-info";
import navBar from "./nav_bar";
import nsGroup from "./ns-group";
import register from "./register";

const domain = {
	add: "Domeinnaam bestellen",
	dns_retrieve_domain_records_dialog: dnsRetrieveDomainRecordsDialog,
	dns_select_template_dialog: dnsSelectTemplateDialog,
	dns_template: dnsTemplate,
	domain: "Domein",
	domain_info: domainInfo,
	empty_list: "U heeft nog geen domeinnamen",
	nav_bar: navBar,
	ns_group: nsGroup,
	register: register,
	title: "Domeinnamen",
};

export default domain;
